const ExploreFarData25 = [
  {
    title: "Downtown La Jolla",
    description: `Charming shops, restaurants, and sea lions sunbathing on the shore. A perfect stroll before or after the conference.`,
    distance: 5,
    url: "https://www.govisitsandiego.com/things-to-do/shopping/shopping-in-downtown-la-jolla/",
  },
  {
    title: "Birch Aquarium at Scripps",
    description: `Interactive exhibits, ocean views, and up-close encounters with marine life.`,
    distance: 2,
    url: "https://aquarium.ucsd.edu/",
  },
  {
    title: "La Jolla Shores & La Jolla Cove",
    description: `Family-friendly beaches, marine life sightings, and beautiful coves for swimming and kayaking.`,
    distance: 4.7,
    url: "https://www.sandiego.gov/lifeguards/beaches/shores",
  },
  {
    title: "Torrey Pines State Natural Reserve",
    description: `Hike coastal trails through one of the last native habitats of rare Torrey pine trees.`,
    distance: 4.8,
    url: "https://www.parks.ca.gov/?page_id=657",
  },
  {
    title: "Museum of Contemporary Art San Diego",
    description: `Explore cutting-edge exhibitions in a scenic, modern museum space.`,
    distance: 4.9,
    url: "https://mcasd.org/",
  },
  {
    title: "Annie’s Canyon Trail",
    description: `A short, adventurous slot canyon hike with fun twists and turns.`,
    distance: 9.7,
    url: "https://naturecollective.org/location/annies-canyon-trail/",
  },
  {
    title: "San Diego Zoo",
    description: `One of the world’s most iconic zoos is nestled in Balboa Park, San Diego’s sprawling cultural hub. The zoo, a pioneer in the concept of open-air, cage-less exhibits, is home to 3,700 rare and endangered animals, and over 700,000 plants.`,
    distance: 16.7,
    url: "https://zoo.sandiegozoo.org/",
  },
  {
    title: "Balboa Park",
    description: `In addition to the San Diego Zoo, Balboa Park boasts 17 museums, miles of hiking trails, performing arts centers, lush gardens, and plenty of dining and shopping opportunities.`,
    distance: 16.7,
    url: "https://balboapark.org/",
  },
  {
    title: "Swim with Otters – Nurtured by Nature",
    description: `This once-in-a-lifetime animal encounter supports wildlife conservation. Reservations are required in advance.`,
    distance: 41.1,
    url: "https://nurturedbynature.org/",
  },
];

export default ExploreFarData25;
